module.exports = __webpack_public_path__ + "img/1.50dac93e.png";